import * as React from "react";
import RadioInput from "@tunnel-components/@sharded/widgets/forms/input/radio/custom/component";
import * as cx from "classnames";
import * as shortid from "shortid";
import * as i18next from "i18next";
import * as Styled from "@tunnel-components/@sharded/@styled/styled";
import StyledIcon from "@tunnel-components/@sharded/@widgets/icons/component";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    masque,
    done,
    myCameraIsConnected,
    myCameraCode,
    onNextMask,
    onRemoveThisMask,
    active,
    onChange,
    checked,
    radio,
    checkZoneMask,
  } = props;

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name shortid
   * @name i18next
   * @infos "https://reactjs.org"
   */
  return (
    <div>
      {masque &&
        masque.map((Elem: any, index: number) => {
          return (
            active &&
            active[index] && (
              <div
                key={index}
                className={cx(
                  {
                    "display-on": active[index],
                    "masque-check": done[index],
                    "masque-uncheck": !done[index],
                  },
                  "segmentation-action animated fadeIn"
                )}
              >
                <div className="masque-segemention-title">
                  <span style={{ backgroundColor: Elem.zoneColorRgbString }}>
                    {i18next.t("masque")} {index + 1}
                  </span>
                  <i />
                </div>
                {myCameraIsConnected && (
                  <div className="masque-segemention-name">
                    <span>{i18next.t("nom masque")} :</span>{" "}
                    <span className="">{i18next.t(Elem.zoneLabel)}</span>
                  </div>
                )}
                <div
                  className="masque-segemention-action"
                  style={{ marginBottom: "0" }}
                >
                  {myCameraIsConnected && <span>{i18next.t("form")} :</span>}
                  {myCameraIsConnected &&
                    radio.map((check: any, keys: number) => {
                      return (
                        <span
                          className={check}
                          key={shortid.generate()}
                          title={check}
                        >
                          <RadioInput
                            disabled={done[index]}
                            name={Elem.label}
                            id={`${Elem.zoneLabel}-${keys}`}
                            checked={checked[index][keys]}
                            onChecked={onChange(index, keys)}
                            label={check}
                          />
                        </span>
                      );
                    })}

                  {!myCameraIsConnected && (
                    <div style={{ textTransform: "none", color: "#ed5b56" }}>
                      <b style={{ fontWeight: "bold" }}>{myCameraCode}</b>
                      {i18next.t("camera pas connecter")}
                    </div>
                  )}

                  {checked[index][1] && !done[index] && (
                    <span onClick={onRemoveThisMask(index, Elem.zoneId)}>
                      <Styled.Icon
                        style={{
                          width: "13px",
                          top: "0px",
                          marginLeft: "20px",
                          right: "unset",
                        }}
                        title={i18next.t("supprimer")}
                      >
                        <StyledIcon Delected={true} color="#007ADF" />
                      </Styled.Icon>
                    </span>
                  )}
                </div>
                <span className="initialization">
                  {checkZoneMask[index] && myCameraIsConnected && (
                    <span
                      className="maskNotFound"
                      style={{ marginBottom: "10px" }}
                    >
                      {" "}
                      {i18next.t(
                        "le modele na pas detecte de masque pour cette voie"
                      )}
                    </span>
                  )}
                  {myCameraIsConnected && !done[index] && (
                    <span
                      className="borderGradian"
                      onClick={onNextMask(index, Elem.zoneId)}
                    >
                      <span
                        className="btnSecondary "
                        style={{
                          backgroundColor: "white",
                          overflow: "visible",
                        }}
                      >
                        <span
                          className="textGradianlarge"
                          style={{ fontSize: "1em" }}
                        >
                          {i18next.t("suivant")}
                        </span>
                      </span>
                    </span>
                  )}
                </span>
              </div>
            )
          );
        })}
    </div>
  );
};

// default props Component
Component.defaultProps = {
  radio: ["auto", "dessiner"],
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  masque?: any;
  done?: any;
  onNextMask?: any;
  onRemoveThisMask?: any;
  active?: any;
  onChange?: any;
  checked?: any;
  radio?: any;
  checkZoneMask?: any;
  myCameraIsConnected?: boolean;
  myCameraCode?: string;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/camera/segmentation/component.tsx